export const COMPANY = {
  name: "Scale Sense",
  short: "SS",
  tagline: "Marketing engineered for the AI world.",
  website: "www.scalesense.in",
  websiteHref: "https://www.scalesense.in",
  phone: "+91-96435 71000",
  phoneHref: "tel:+919643571000",
  whatsapp: "https://wa.me/919643571000",
  email: "vikram@scalesense.in",
  emailHref: "mailto:vikram@scalesense.in",
  address: "56, 2nd Floor, Pocket 7, Dwarka Sec 23 B, Delhi - 110077",
  city: "New Delhi, India",
  founder: "Vikram Hooda",
  founderInitials: "VH",
};

export const BRAND_3D = {
  base: "#3DD68C",
  light: "#7EEDB8",
  shadow: "#1EA362",
};

export const SOCIAL = {
  linkedin: "https://in.linkedin.com/company/scale-sense",
  instagram: "https://www.instagram.com/scalesense.in/",
  facebook: "https://www.facebook.com/profile.php?id=61574652731990",
};

export const CHAPTERS = [
  { id: "hero", label: "Hero" },
  { id: "problem", label: "The Problem" },
  { id: "positioning", label: "Positioning" },
  { id: "services", label: "Services" },
  { id: "industries", label: "Industries" },
  { id: "how-we-work", label: "How We Work" },
  { id: "numbers", label: "Numbers" },
  { id: "founder", label: "Founder" },
  { id: "contact", label: "Contact" },
];

export const NAV_LINKS = [
  { id: "problem", label: "Problem" },
  { id: "services", label: "Services" },
  { id: "industries", label: "Industries" },
  { id: "how-we-work", label: "Process" },
  { id: "numbers", label: "Proof" },
  { id: "blog", label: "Blog", href: "/blog" },
  { id: "contact", label: "Contact" },
];

export const SERVICES = [
  {
    key: "brand-story",
    number: "01",
    tag: "Brand",
    title: "Brand & Story",
    description:
      "Positioning, naming and identity built so customers — not just decks — actually remember you.",
    objectKind: "prism",
    subServices: [
      "Brand Audit & Diagnosis",
      "Positioning Strategy",
      "Naming & Identity",
      "Messaging Framework",
      "Brand Voice & Tone",
      "Founder Narrative",
      "Competitive Differentiation",
      "Rebranding",
    ],
  },
  {
    key: "content-creative",
    number: "02",
    tag: "Creative",
    title: "Content & Creative",
    description:
      "More creatives every week so your ads stop fatiguing in 7 days — videos, reels, posts, blogs, design.",
    objectKind: "cards",
    subServices: [
      "Performance Ad Creatives",
      "Video & Reels Production",
      "Podcast Production",
      "SEO Blog Writing",
      "Graphic & Brand Design",
      "Motion Graphics",
      "Photography Direction",
      "UGC Campaign Production",
      "Email & Notification Copy",
      "Regional / Hindi Content",
    ],
  },
  {
    key: "social-influencer",
    number: "03",
    tag: "Social",
    title: "Social Media & Influencer",
    description:
      "Daily ops on your handles plus the right creators — so the brand actually shows up where buyers scroll.",
    objectKind: "sphere",
    subServices: [
      "Social Media Management (Daily Ops)",
      "Content Calendars & Posting",
      "Community & DM Management",
      "Influencer & Creator Partnerships",
      "Tier-2 / Regional Creators",
      "Meme & Trend Marketing",
      "Reels & Short-Form Video",
      "Social Listening & Reporting",
    ],
  },
  {
    key: "website-funnel",
    number: "04",
    tag: "Web",
    title: "Website & Funnel",
    description:
      "Websites and funnels that don't just look premium — they convert. Built fast, measured properly.",
    objectKind: "torus",
    subServices: [
      "Website Design & Development",
      "Landing Page Design & Build",
      "E-commerce / Shopify Build",
      "Mobile App / UI Design",
      "Conversion Rate Optimisation (CRO)",
      "A/B & Multivariate Testing",
      "Analytics & Pixel Setup",
      "Page Speed & SEO Tech",
    ],
  },
  {
    key: "growth-performance",
    number: "05",
    tag: "Growth",
    title: "Growth & Performance",
    description:
      "AI-tuned media buying that pulls cost-per-lead down and ROAS up — without burning rupees on vanity reach.",
    objectKind: "arrow",
    subServices: [
      "Meta Ads (Facebook + Instagram)",
      "Google Ads (Search + Performance Max)",
      "YouTube & Programmatic",
      "SEO & SEM",
      "App Store Optimisation",
      "Affiliate Marketing",
      "Lead Generation Campaigns",
      "Retargeting & Funnel Recovery",
    ],
  },
  {
    key: "crm-retention",
    number: "06",
    tag: "Retention",
    title: "CRM, WhatsApp & Retention",
    description:
      "Email, WhatsApp and lifecycle journeys that turn one-time buyers into repeat revenue. Compounds month-on-month.",
    objectKind: "gear",
    subServices: [
      "WhatsApp Marketing & Automation",
      "Email Marketing & Newsletters",
      "Lifecycle & Drip Campaigns",
      "CRM Setup (HubSpot / Zoho / Salesforce)",
      "Marketing Automation Workflows",
      "Loyalty & Referral Programmes",
      "Dashboards & Attribution",
      "Customer Data Platform (CDP)",
    ],
  },
  {
    key: "cmo-advisory",
    number: "07",
    tag: "Advisory",
    title: "CMO & Advisory",
    description:
      "Fractional CMO and senior marketing muscle on tap — for founders who can't yet hire a full leadership team.",
    objectKind: "lightbulb",
    subServices: [
      "Fractional CMO / CMO-as-a-Service",
      "Marketing Audit & Roadmap",
      "Go-to-Market Strategy",
      "PR & Press Outreach",
      "Investor & Fundraise Marketing",
      "Marketing Team Building & Hiring",
      "Board-Level Marketing Reporting",
      "Competitive Intelligence",
    ],
  },
];

export const INDUSTRIES = [
  "D2C & Commerce",
  "SaaS & Software",
  "Real Estate",
  "Healthcare",
  "Fintech",
  "Education",
  "Luxury & Lifestyle",
  "F&B and Hospitality",
  "Fashion & Apparel",
  "Beauty & Wellness",
  "Travel & Experiences",
  "Automotive",
  "Legal & Professional",
  "Personal Creators",
  "Astrology & Spiritual",
  "Coaching & EdTech",
  "& more",
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Diagnose",
    primitive: "sphere",
    description:
      "We audit your funnel, market and creative. We identify the bottleneck blocking scale — not a symptom, the cause.",
  },
  {
    n: "02",
    title: "Architect",
    primitive: "cube",
    description:
      "We design a marketing system: positioning, channel mix, creative engine, measurement and automations.",
  },
  {
    n: "03",
    title: "Deploy",
    primitive: "arrow",
    description:
      "Campaigns, content and workflows go live. AI does the heavy lifting. Humans steer strategy and craft.",
  },
  {
    n: "04",
    title: "Compound",
    primitive: "torus",
    description:
      "Weekly optimisation, quarterly replanning. Every cycle gets smarter, faster and more efficient than the last.",
  },
];

export const NUMBERS = [
  { value: 15, suffix: "+", label: "Industries served" },
  { value: 75, suffix: "+", label: "Brands scaled" },
  { value: 250, suffix: "+", label: "Campaigns launched" },
  { value: 90, suffix: "%", label: "Client retention" },
];

export const PROBLEM_STATES = [
  {
    eyebrow: "The shift already happened",
    title: "The AI bandwagon isn't coming. It left the station.",
    bullets: [
      "Creative production is now cents on the rupee",
      "Search moved from Google-only to ChatGPT, Gemini, Perplexity",
      "Attention is personalised — generic no longer works",
      "Speed of iteration has overtaken size of budgets",
    ],
  },
  {
    eyebrow: "The cost of waiting",
    title: "Every quarter without AI is a quarter of handed-over market share.",
    bullets: [
      "Competitors ship 10× more creative, tested live",
      "Your CAC creeps up while theirs compounds down",
      "Your team spends weeks on what AI delivers in hours",
      "The gap widens faster than any hiring plan can close it",
    ],
  },
  {
    eyebrow: "Where Scale Sense comes in",
    title: "Get on the AI bandwagon. Fast. Without breaking your brand.",
    bullets: [
      "We architect the stack — you keep running the business",
      "Human craft on strategy and story; AI on production and scale",
      "Measurable wins inside 30 days, compounding inside 90",
      "One partner instead of eight disconnected vendors",
    ],
  },
];

export const POSITIONING_STATS = [
  { value: "10x", label: "Faster campaign velocity" },
  { value: "40%", label: "Lower cost per acquisition" },
  { value: "24/7", label: "Always-on growth system" },
];
